<div class="metrics-container">
    <!-- Desktop: Grid Flow -->
    <div class="hidden md:flex items-center gap-2">
        <div *ngFor="let item of items" [class]="getVariantClasses(item)" (click)="onItemClick(item)" class="group shrink-0">

            <div [class]="getIconClasses(item.variant)">
                <iconify-icon [icon]="item.icon" width="16"></iconify-icon>
            </div>

            <div class="flex flex-col">
                <span class="text-base font-black leading-none text-foreground tracking-tight">
                    {{ item.value }}
                </span>
                <span class="text-[8px] font-black uppercase tracking-wider text-foreground/30 mt-0.5">
                    {{ item.label }}
                </span>
            </div>
        </div>
    </div>

    <!-- Mobile: Dropdown -->
    <div class="md:hidden relative">
        <button type="button" (click)="showMobileMenu = !showMobileMenu; $event.stopPropagation()"
            class="w-9 h-9 flex items-center justify-center bg-surface/40 hover:bg-surface/60 border border-foreground/5 rounded-xl text-primary transition-all cursor-pointer">
            <iconify-icon icon="solar:chart-square-bold-duotone" width="18"></iconify-icon>
        </button>

        <!-- Overlay Menu -->
        <div *ngIf="showMobileMenu"
            class="absolute right-0 top-full mt-2 w-48 bg-white dark:bg-slate-800 border border-foreground/[0.05] shadow-lg rounded-2xl p-2 z-50 flex flex-col gap-1 animate-fade-in origin-top-right">

            <div *ngFor="let item of items" (click)="onItemClick(item)"
                class="flex items-center gap-3 p-2 rounded-xl hover:bg-foreground/[0.03] dark:hover:bg-slate-700 transition-colors"
                [class.cursor-pointer]="item.clickable">

                <div [class]="getIconClasses(item.variant)" class="w-8 h-8 rounded-lg flex-shrink-0">
                    <iconify-icon [icon]="item.icon" width="16"></iconify-icon>
                </div>

                <div class="flex flex-col flex-1 min-w-0">
                    <span class="text-[10px] font-black uppercase tracking-wider text-foreground/40">{{ item.label
                        }}</span>
                    <span class="text-sm font-black text-foreground">{{ item.value }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
